var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolygon = function SvgPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#8949E2",
    rx: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#polygon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.748 39.002c-1.196-.672-2.734-.672-4.102 0l-9.57 5.54-6.494 3.527-9.4 5.541c-1.196.672-2.734.672-4.1 0l-7.35-4.366a4.08 4.08 0 0 1-2.05-3.526v-8.395c0-1.344.683-2.687 2.05-3.526l7.35-4.198c1.195-.672 2.733-.672 4.1 0l7.35 4.366a4.08 4.08 0 0 1 2.05 3.526v5.54l6.494-3.693v-5.71c0-1.343-.683-2.686-2.05-3.525L37.352 22.21c-1.196-.672-2.734-.672-4.101 0l-14.014 8.06c-1.367.671-2.05 2.014-2.05 3.358v15.783c0 1.343.683 2.687 2.05 3.526l13.843 7.892c1.196.672 2.734.672 4.102 0l9.399-5.373 6.494-3.694 9.4-5.373c1.196-.672 2.734-.672 4.101 0l7.349 4.198a4.08 4.08 0 0 1 2.05 3.526v8.395c0 1.344-.683 2.687-2.05 3.526l-7.178 4.198c-1.196.672-2.734.672-4.102 0l-7.348-4.198a4.08 4.08 0 0 1-2.05-3.526v-5.373l-6.495 3.694v5.541c0 1.344.684 2.687 2.05 3.526l13.844 7.892c1.196.672 2.734.672 4.101 0l13.843-7.892a4.08 4.08 0 0 0 2.05-3.526V50.42c0-1.344-.683-2.687-2.05-3.526z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "polygon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.188 21.875h65.625v56.25H17.188z"
  })))));
};
export default SvgPolygon;